import { atom, selector } from "recoil";

import {
  ConsultType,
  DoctorModel,
  GetPatientByIdsDocument,
  PatientModel,
  PlatformType
} from "graphql/generated";
import graphQLClient from "graphql/react-query";
import { Coupon } from "src/types/coupon";

import keys from "./constants";

export const platformState = atom<PlatformType>({
  key: keys.PLATFORM_STATE,
  default: PlatformType.Noah
});

export const patientCheckoutInfoState = atom<any>({
  key: keys.PATIENT_CHECKOUT_INFO_STATE,
  default: undefined
});

export const routerChangeState = atom({
  key: keys.ROUTER_CHANGE_STATE,
  default: 0
});

export const referrerCouponState = atom({
  key: keys.REFERRER_PROMOTION_CODE_STATE,
  default: {
    id: "REFERRER",
    name: "REFERRER",
    valid: true,
    percent_off: 0,
    amount_off: 10,
    duration: "",
    metadata: {},
    currency: "sgd",
    max_redemptions: 1
  } as Coupon
});

export const countryState = atom({
  key: keys.COUNTRY_STATE,
  default: {
    country: process.env.NEXT_PUBLIC_COUNTRY,
    currency: process.env.NEXT_PUBLIC_COUNTRY === "sg" ? "sgd" : "hkd"
  }
});

export const isLoadingState = atom<boolean>({
  key: keys.IS_LOADING_STATE,
  default: true
});

export const patientState = atom<PatientModel>({
  key: keys.PATIENT_STATE,
  default: undefined
});

export const doctorState = atom<DoctorModel>({
  key: keys.DOCTOR_STATE,
  default: undefined
});

export const patientDataState = selector<PatientModel | null>({
  key: "PATIENT_DATA_STATE",
  get: async ({ get }) => {
    const patient = get(patientState);
    get(routerChangeState);

    if (!patient) return null;

    const patientData = await graphQLClient.request(GetPatientByIdsDocument, {
      input: {
        ids: [patient.sysId]
      }
    });

    if (patientData?.getPatientByIds[0]) {
      return patientData.getPatientByIds[0];
    }

    return null;
  }
});

export const userDataState = selector<PatientModel | null>({
  key: "USER_DATA_STATE",
  get: async ({ get }) => {
    const patient = get(patientState);
    if (!patient) {
      return null;
    }

    const patientData = await graphQLClient.request(GetPatientByIdsDocument, {
      input: {
        ids: [get(patientState).sysId]
      }
    });

    if (patientData?.getPatientByIds[0]) {
      return patientData.getPatientByIds[0];
    }

    return null;
  }
});

export const insightPastNotesFilterState = atom<string>({
  key: keys.INSIGHT_PAST_NOTES_FILTER_STATE,
  default: ConsultType.All
});

export const emailPermissionModalState = atom<boolean>({
  key: keys.EMAIL_PERMISSION_MODAL_STATE,
  default: false
});
